import * as ELG from 'esri-leaflet';
import { WCC_BOUNDARY_LAYER } from './constants';
import { geoJSON } from 'leaflet';
import extendedBoundaryGeojson from './WCC_EXTENDED_BOUNDARY.json';

export const boroughBoundaryLayer = ELG.featureLayer({
  url: WCC_BOUNDARY_LAYER,
  simplifyFactor: 0.5,
  precision: 5,
  style(feature, layer) {
    return { color: '#5897fcad', weight: 2 };
  },
});

export const boroughBufferBoundaryLayer = geoJSON(
  extendedBoundaryGeojson as GeoJSON.GeoJsonObject,
);
